$(function () {
	const $attachedInputs = {};

	$('.image-picker-container .field-buttons-container .pick-from-computer').on('click', function () {
		const $button = $(this);
		const inputSelector = $(this).data('input');
		let $input = $attachedInputs[inputSelector];

		if (typeof ($input) === 'undefined') {
			$input = $(inputSelector);
			$input.on('change', function (e) {
				const input = e.target;
				const files = input.files;

				// console.log("Input.change: " + $(input).data('buttons-container').data('preview-image'));

				var done = function (url) {
					input.value = '';
					ImagePickers.cropImage(url, $(input).data('buttons-container'));
				};
				if (files && files.length > 0) {
					let file = files[0];

					if (URL) {
						done(URL.createObjectURL(file));
					} else if (FileReader) {
						let reader = new FileReader();
						reader.onload = function (e) {
							done(reader.result);
						};
						reader.readAsDataURL(file);
					}
				}
			});
			$attachedInputs[inputSelector] = $input;
		}
		$input.data('buttons-container', $button.parents('.field-buttons-container'));
		$input.click();
	});

	$('.image-picker-container .field-buttons-container .pick-from-library').on('click', function () {
		const $button = $(this);
		const $container = $button.parents('.field-buttons-container');
		const $popup = $($container.data('library-popup'));
		if ($popup.length > 0) {
			$popup.addClass('visible');
			var s3 = new S3Client("ct-image-library", "eu-west-1", "eu-west-1:c9806491-ff19-4eaf-b0e8-72e9b57e1c88", `${$container.data('library-popup')} .s3-viewer-images`, function (url) {
				$popup.removeClass('visible');
				ImagePickers.cropImage(url, $container);
			});
			s3.viewAlbum("");
		}
	});

	$('.image-picker-container .field-buttons-container .remove').on('click', function () {
		const $button = $(this);
		const $container = $button.parents('.field-buttons-container');
		const $input = $($container.data('result-input'));
		const $image = $($container.data('preview-image'));
		$input.val("-");
		$image.attr("src", "");

		ImagePickers.checkPlaceholder($image.parents('.image-picker-container'));
	});

	$('#crop-image-popup .popup-buttons .cancel-button.cancel, #s3-popup .popup-buttons .cancel-button.cancel').click(function () {
		$(this).parents('.visible').removeClass('visible');
	});


});

/**
 * @namespace
 * @global
 */
const ImagePickers = {
	/** @type {CTCropper} */
	cropper: null,
	/** @type {jQuery} */
	$okButton: null,
	/** @type {jQuery} */
	$resetCropBoxButton: null,
	/** @type {number} */
	scale: 2,
	/** @type {number} */
	displayScale: 1,

	/**
	 * Checks if the placeholder needs to be visible
	 * @param {jQuery} $container The image picker container
	 */
	checkPlaceholder: function ($container) {
		let hasSelectedImage = false;
		$container.find('.preview-image').each(function (index) {
			if (this.src != "" && this.src != window.location.href)
				hasSelectedImage = true;
		});
		if (hasSelectedImage)
			$container.find('.placeholder').hide();
		else
			$container.find('.placeholder').show();
	},
	/**
	 * @param {string} url
	 * @param {jQuery} $buttonsContainer
	 */
	cropImage: function (url, $buttonsContainer) {
		const cropperPadding = 20;
		const popupPadding = 15;

		if ($buttonsContainer.length == 0)
			console.error("Buttons container not found.");

		const popupSelector = $buttonsContainer.data('crop-popup');
		const width = $buttonsContainer.data('target-width');
		const height = $buttonsContainer.data('target-height');

		const $resultInput = $($buttonsContainer.data('result-input'));
		if ($resultInput.length == 0)
			console.error("Result input not found: '" + $buttonsContainer.data('result-input') + "'.");
		const $previewImage = $($buttonsContainer.data('preview-image'));
		if ($previewImage.length == 0)
			console.error("Preview image not found: '" + $buttonsContainer.data('result-input') + "'.");
		const allowHResize = $buttonsContainer.data('allow-h-resize');
		const allowVResize = $buttonsContainer.data('allow-v-resize');
		const $popup = $(popupSelector);
		if ($popup.length == 0)
			console.error("Popup not found: '" + popupSelector + "'.");

		const overlays = [];
		for (var i = 0; i < 10; i++) {
			const overlay_width = $buttonsContainer.data('overlay-width-' + i);
			const overlay_height = $buttonsContainer.data('overlay-height-' + i);
			const overlay_classes = $buttonsContainer.data('overlay-classes-' + i);
			if (!overlay_width || !overlay_height || !overlay_classes)
				break;
			overlays.push({
				classes: overlay_classes,
				width: overlay_width,
				height: overlay_height
			});
		}

		const $popupContainer = $popup.find('.popup-container');
		const $cropImage = $popup.find('.crop-image');
		const $cropImageContainer = $popup.find('.image-container');

		if (ImagePickers.$okButton === null) {
			ImagePickers.$okButton = $popup.find('.form-actions .action-button');
			ImagePickers.$okButton.click(function () {
				const $button = $(this);
				const dataUrl = ImagePickers.cropper.getCroppedImageDataUrl(ImagePickers.scale);
				const $image = $button.data('preview-image');
				$button.data('result-input').val(dataUrl);
				$image.attr("src", dataUrl);
				$(this).parents('.visible').removeClass('visible');

				ImagePickers.checkPlaceholder($image.parents('.image-picker-container'));
			});
		}
		ImagePickers.$okButton.data('preview-image', $previewImage);
		ImagePickers.$okButton.data('result-input', $resultInput);

		if (ImagePickers.$resetCropBoxButton === null) {
			ImagePickers.$resetCropBoxButton = $popup.find('.form-actions .cancel-button.reset-crop-box');
			ImagePickers.$resetCropBoxButton.click(function () {
				ImagePickers.cropper.resetCropBox();
			});
		}

		$cropImage.attr('src', url);
		$cropImageContainer.css('width', ImagePickers.displayScale * width + (2 * cropperPadding) + "px");
		$cropImageContainer.css('height', ImagePickers.displayScale * height + (2 * cropperPadding) + "px");

		const popupWidth = ImagePickers.displayScale * width + (2 * popupPadding) + (2 * cropperPadding);
		$popupContainer.css('width', popupWidth + "px");
		$popupContainer.css('margin-left', -(popupWidth / 2) + "px");

		$popup.addClass('visible');

		if (ImagePickers.cropper != null) {
			ImagePickers.cropper.reset($cropImage[0], ImagePickers.displayScale * width, ImagePickers.displayScale * height, cropperPadding, allowVResize, allowHResize, overlays);
		} else {
			ImagePickers.cropper = new CTCropper(
				$cropImage[0],
				ImagePickers.displayScale * width,
				ImagePickers.displayScale * height,
				cropperPadding,
				allowVResize,
				allowHResize,
				overlays,
				function () {
					$(".image-container").removeClass("error");
					$(".image-container").addClass("loading");
				},
				function () {
					$(".image-container").removeClass("loading");
				},
				function () {
					$(".image-container").addClass("error");
				}
			);
		}
	},
};
